module.exports = __webpack_public_path__ + "static/Trans-11-Clean-8ed348da5a080160a15ab5ac153dcb8f.svg";